import React from "react";

const PremiumLabel = ({ children, className=null }) => (
  <div className={`ttu f--3 dib ${className}`}>{children}</div>
);

const Overlay = ({ children, className }) => (
  <div className={`absolute w-100 ${className}`}>{children}</div>
);

Overlay.defaultProps = {
  className: "top-0 left-0 a-bg-gradient-2-rev"
};

const PremiumStoryOverlay = ({ premium, text }) =>
  premium ? (
    <Overlay>
      <PremiumLabel className="t-ma1 ba b--white br2 a-premium-label white">
        {text}
      </PremiumLabel>
    </Overlay>
  ) : null;

export { PremiumLabel, Overlay, PremiumStoryOverlay };
